import React, { Component } from 'react';
import Header from '../header';
import Footer from '../footer';
import * as firebase from "firebase";
import { List, Avatar, Button, Skeleton } from 'antd';

class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            initLoading: true
        }
    }

    componentDidMount() {
        this.getOrders();
    }

    getOrders() {
        const currentUser = firebase.auth().currentUser;
        console.log(currentUser)
        const starCountRef = firebase.database().ref(`carts/${currentUser.uid}`);
        starCountRef.on('value', (snapshot) => {
            this.setState({
                orders: snapshot.val() ? Object.values(snapshot.val()) : [],
                initLoading: false
            });
        }, (err) => {
        });
    }


    render() {
        const { orders = [], initLoading } = this.state;
        console.log(orders)
        return (
            <div>
                <Header search="true" />
                <Footer />
                <List
                    className="demo-loadmore-list"
                    loading={initLoading}
                    itemLayout="horizontal"
                    dataSource={orders}
                    renderItem={item => {
                        console.log('item',item);
                        
                        return (
                            <table class="table table-hover table-responsive-sm ">
                                <thead>
                                    <tr>
                                        <th>Image</th>
                                        <th>Name</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{width:"33%"}}>
                                            <img style={{width:"40%"}} src={item.selectedProduct.imgUrl} />
                                        </td>
                                        <td>{item.selectedProduct.name}</td>
                                        <td>{item.selectedProduct.price}</td>
                                    </tr>
                                </tbody>
                            </table>
                        )
                    }
                    }
                />
            </div>
        );
    }
}

export default Orders;